import moment from 'moment';
import { useContext } from 'react';
import { DefaultDatesRangeContext } from './default_dates_range_context';
import { getDefaultDatesRange } from './get_default_dates_range';

/** @return {[moment.Moment, moment.Moment]} */
export const useDefaultDatesRange = () => {
  const context = useContext(DefaultDatesRangeContext);

  if (!context) {
    return Object.values(getDefaultDatesRange());
  }

  return [context.dateStartDefault, context.dateEndDefault];
};
